module.exports = __webpack_public_path__ + "img/sprava-staveb.a08a67de.svg";